/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* Threaded by Sal, 2026-09-11: variant picker helpers.
   1. When a Style or Color click lands on a combination that does not exist,
      jump to the first available variant that keeps the clicked value.
   2. Hide option values that exist in no variant for the earlier selections
      (dead combinations). Sold-out values that do exist stay visible, struck. */
(function () {
  function allVariants(vr) {
    var el = vr.querySelector('[id^="all-variant-data-"]');
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function selected(vr) {
    return Array.from(vr.querySelectorAll('fieldset')).map(function (fs) {
      var r = fs.querySelector('input:checked'); return r ? r.value : null;
    });
  }
  function hideDead(vr) {
    var variants = allVariants(vr); if (!variants.length) return;
    var sel = selected(vr);
    Array.from(vr.querySelectorAll('fieldset')).forEach(function (fs, idx) {
      if (idx === 0) return;
      Array.from(fs.querySelectorAll('input')).forEach(function (input) {
        var cand = sel.slice(); cand[idx] = input.value;
        var exists = variants.some(function (v) {
          return v.options.slice(0, idx + 1).every(function (o, i) { return o === cand[i]; });
        });
        var item = input.closest('.product-form__swatch__item') || input.parentElement;
        if (item) item.hidden = !exists;
      });
    });
  }
  function jump(vr, input) {
    var variants = allVariants(vr); if (!variants.length) return;
    var fieldsets = Array.from(vr.querySelectorAll('fieldset'));
    var idx = fieldsets.findIndex(function (fs) { return fs.contains(input); });
    if (idx < 0) return;
    var sel = selected(vr);
    var exists = variants.some(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    if (exists) return;
    var target = variants.find(function (v) { return v.available && v.options[idx] === input.value; }) ||
                 variants.find(function (v) { return v.options[idx] === input.value; });
    if (!target) return;
    target.options.forEach(function (val, i) {
      if (i === idx || !fieldsets[i]) return;
      var r = Array.from(fieldsets[i].querySelectorAll('input')).find(function (x) { return x.value === val; });
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    var vr = input.closest('variant-radios'); if (!vr) return;
    jump(vr, input);
  }, true);
  document.addEventListener('variant:changed', function () {
    document.querySelectorAll('variant-radios').forEach(hideDead);
  });
  function init() { document.querySelectorAll('variant-radios').forEach(hideDead); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
